import {
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { useFormikContext } from 'formik';
import React from 'react';

const useStyles = makeStyles(theme => ({
  navigationButtonsPhone: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    padding: theme.spacing(),
    zIndex: 99,
    background: 'white',
    paddingBottom: `calc(env(safe-area-inset-bottom) + 8px)`
  },
  navigationButtonsDesktop: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}));

export default function NavigationButtons({
  activeStep,
  isPhone,
  steps,
  loadingSendPre,
  handleBack
}) {
  const classes = useStyles();
  const { isSubmitting } = useFormikContext();

  const getEndIcon = () => {
    if (isSubmitting || loadingSendPre) {
      return <CircularProgress size={20} />;
    }
    return <NavigateNextIcon />;
  };

  const getNextButtonText = () => {
    if (activeStep === steps.length - 1) {
      return 'Enviar Formulario';
    }
    return 'Siguiente';
  };
  return (
    <Container maxWidth="lg">
      <Grid
        container
        alignItems="flex-end"
        justifyContent="flex-end"
        // spacing={4}
        className={
          isPhone
            ? classes.navigationButtonsPhone
            : classes.navigationButtonsDesktop
        }
      >
        <Grid item>
          <Button
            onClick={handleBack}
            className={classes.backButton}
            size={isPhone ? 'small' : 'medium'}
            disabled={activeStep === 0}
            startIcon={<NavigateBeforeIcon />}
          >
            Atrás
          </Button>
        </Grid>
        <Divider
          orientation="vertical"
          flexItem
          style={{ marginLeft: 20, marginRight: 20 }}
        />
        <Grid item>
          {activeStep === steps.length ? (
            <Typography className={classes.instructions}>Finalizado</Typography>
          ) : (
            <>
              <Button
                type="submit"
                color="primary"
                disabled={isSubmitting || loadingSendPre}
                variant={
                  activeStep === steps.length - 1 ? 'contained' : 'outlined'
                }
                size={isPhone ? 'small' : 'medium'}
                endIcon={getEndIcon()}
              >
                {getNextButtonText()}
              </Button>
            </>
          )}
        </Grid>
      </Grid>
    </Container>
  );
}
